import { render, staticRenderFns } from "./HeaderInformationComponent.vue?vue&type=template&id=246ac639&scoped=true"
import script from "./HeaderInformationComponent.vue?vue&type=script&lang=js"
export * from "./HeaderInformationComponent.vue?vue&type=script&lang=js"
import style0 from "./HeaderInformationComponent.vue?vue&type=style&index=0&id=246ac639&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246ac639",
  null
  
)

export default component.exports